import * as React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center text-sm text-center bg-gray-100 h-14">
      <div className="flex justify-center divide-x divide-black ">
      <div className="px-2">{t("app.copyright")} {t("app.brandName")}</div>
      <div className="px-2">{t("app.privacyPolicy")}</div>
      <div className="px-2">{t("app.termsOfService")}</div>
      </div>
    </div>
  );
};

export default Footer;
